import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksisunits', config);
}

const get = async (code) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksisunits/' + code);
}

const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/yoksisunits/', data);
}

const update = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/yoksisunits/' + id, formData);
}

const deleteYoksis = async (code) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/yoksisunits/' + code);
}

const studentSearchExcelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/service/student-search-excel-export', config);
}

const undergraduateListExcel = async (year) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/service/undergraduate-list-excel-export/'+year)
}

const educationInformation = async (nationalId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/service/education-information/'+nationalId)
}

const graduateInformation = async (nationalId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/service/graduate-information/'+nationalId)
}

const kykInformation = async (nationalId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/service/kyk-information/'+nationalId)
}

const asalInformation = async (nationalId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/service/asal-information/'+nationalId)
}

const mebInformation = async (nationalId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/service/meb-graduate-information/'+nationalId)
}

const equivalenceInformation = async (nationalId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/service/equivalence-information/'+nationalId)
}

const sentInformation = async (nationalId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/service/yoksis-sent-information/'+nationalId)
}

const prepDetailList = async (nationalId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/service/prep-detail-list-excel-export/'+nationalId)
}

const pedagogicList = async (nationalId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/service/pedagogic-formation-list-excel-export/'+nationalId)
}

const leaveOfAbsenceList = async (nationalId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/service/leave-of-absence-list-excel-export/'+nationalId)
}

const punishmentList = async (nationalId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/service/punishment-list-excel-export/'+nationalId)
}

const studentList = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/yoksis/service/student-list-excel-export', formData)
}

const otherUniversityStudentsList = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/yoksis/service/other-university-students-excel-export', formData)
}

const bulkMebGraduateList = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/yoksis/service/bulk-meb-graduate-information-excel-export', formData)
}

const yoksisUniversities = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/universities', config);
}

const yoksisUniversityUnits = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/unit/informations', config);
}

const yoksisUnitsUpdate = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/yoksis/service/update-university-and-units');
}
const multipleActionExcel = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/yoksis/service/bulk-yoksis-graduate-information-excel-export', formData)
}

export default {
    getAll,
    get,
    store,
    update,
    deleteYoksis,
    studentSearchExcelExport,
    undergraduateListExcel,
    educationInformation,
    graduateInformation,
    kykInformation,
    asalInformation,
    mebInformation,
    equivalenceInformation,
    sentInformation,
    prepDetailList,
    pedagogicList,
    leaveOfAbsenceList,
    punishmentList,
    studentList,
    otherUniversityStudentsList,
    bulkMebGraduateList,
    yoksisUniversities,
    yoksisUniversityUnits,
    yoksisUnitsUpdate,
    multipleActionExcel
}
